// removed by extract-text-webpack-plugin
module.exports = {"home_video":"src-styles-components-home----homeVideo-module---home_video---l68WC"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/home/homeVideo.module.scss
// module id = 403
// module chunks = 153662236231701